import { FETCH_RETRY_COUNT, FETCH_RETRY_DELAY } from './constants'
import { commonServerLogger } from './logger'
import { sleep } from './utils'

interface RetryFetchParams {
  retryCount: number
  callFetch: () => Promise<any>
  fetchFunctionName?: string
}

export const retryFetch = async ({ callFetch, retryCount, fetchFunctionName }: RetryFetchParams) => {
  if (retryCount < FETCH_RETRY_COUNT) {
    commonServerLogger('info', `Retrying fetch`, { fetchFunctionName, retryCount })

    await sleep(FETCH_RETRY_DELAY)
    return await callFetch()
  }
}
